export default "__VITE_ASSET__cf71b850__"